export const FILTER_COL = {
  xl: 'auto',
  lg: 'auto',
  md: 4,
  sm: 6,
  cols: 12,
}

export const FILTER_STATUS_COL = {
  xl: 'auto',
  lg: 'auto',
  md: 3,
  sm: 6,
  cols: 12,
}

export const FILTER_ACTION_COL = {
  xl: 'auto',
  lg: 'auto',
  md: 5,
  sm: 6,
  cols: 12,
}